module.exports = __webpack_public_path__ + "static/media/video.c9e13e97.mp4";